import { Directive, ElementRef, Input } from "@angular/core";
import { IRequestPermission } from "@schema/permissions";
import { PermissionService } from "@core/service/permission.service";

@Directive({
  selector: "[appEnableButtonIfUserCan]"
})
export class EnableButtonIfUserCanDirective {

  /**
   * The original title attribute of the element
   */
  protected _originalTitle: string;

  constructor(
    protected _element: ElementRef,
    protected _permissionService: PermissionService,
  ) {
    // Store the original title in the event we need to switch it back at some point
    this._originalTitle = _element.nativeElement.hasAttribute("title") ?
      _element.nativeElement.getAttribute("title") : "";
  }

  @Input("appEnableButtonIfUserCan") set appEnableButtonIfUserCan(request: IRequestPermission) {
    const userCan = this._permissionService.can(request.permission, request.global);

    this._element.nativeElement.disabled = !userCan;
    this._element.nativeElement.setAttribute("title", !userCan ? "You do not have the proper access to do this" : this._originalTitle);
  }

}
